module.exports = __webpack_public_path__ + "img/doctor-final.46d49e09.jpg";